/**
 * 문제 보기 칸의 기본 폭(px) — 문제 v2(ProblemHub) 두 칸의 왼쪽 칸과 강의 작업 칸의 오른쪽 결과 칸이
 * 처음에는 **같은 값**을 쓴다(설계 learning-composition-v2/FE-20260913 §6).
 * ProblemHub 는 사용자가 두 칸 경계를 끌면 로컬에 기억한 폭으로 바뀌고, 강의 작업 칸은 이 기준값을 유지한다.
 * 기본 숫자를 바꿀 때 두 화면을 따로 고치지 않도록 여기서만 정한다.
 *
 * 본문 글자 폭 = 미리보기 본문 폭(PAPER_BODY_PX 423). A4 인쇄 본문 칸 281.55px 의 1.5024배라 발문·선지가
 * 미리보기(=종이)와 같은 자리에서 꺾인다(오너 지시 2026-09-11 「문제 보기 영역의 폭은 문제 미리보기(출력시 기준) 폭으로」).
 *
 *   34  편집기 테두리 1×2(ProblemViewTab 의 rounded-xl border) + 글자 칸 안쪽 여백 16×2
 *       (App.css `.ocr-lexical-editor div.ContentEditable__root`). 그 여백이 바뀌면 글자 폭이 423 에서 어긋난다.
 *   488 칸 = 457 + 오른쪽 여백 16(pr-4) + 스크롤바 자리 15(늘 보이는 스크롤바. 겹침 스크롤바는 0 —
 *       넓은 쪽으로 셈한다. 자리는 scrollbar-gutter 로 늘 잡아 두어 글자 폭이 스크롤 유무에 흔들리지 않는다).
 */
import { PAPER_BODY_PX } from '../ExamPapersV2/ProblemBodyPreview';

export const VIEW_CONTENT_PX = PAPER_BODY_PX + 34;
export const VIEW_PANE_PX = VIEW_CONTENT_PX + 16 + 15;
